export interface ThemeOption {
    value: string;
    label: string;
}

export const themeOptions: ThemeOption[] = [
    { value: 'system', label: 'System' },
    { value: 'light',  label: 'Light'  },
    { value: 'dark',   label: 'Dark'   },
];
